import React, { Fragment, useEffect, useState } from 'react';
import { Link } from "react-router-dom";

// import material UI
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid, RowsProp, ColDef } from '@material-ui/data-grid';
import { Paper, Button } from '@material-ui/core';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Visibility as VisibilityIcon
} from '@material-ui/icons';

import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

// import action
import { getAllAdmin,deleteAdmin } from './../../actions/admin';
import {toastAlert} from '../../lib/toastAlert'

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    flexHeader: {
        display: "flex !important",
        justifyContent: "space-between !important",
        alignItems: "center !important"
    },
    btnPrimary: {
        backgroundColor: "#b462c5",
        color: "#ffffff !important",
        padding: "7px 15px",
        fontSize: "12px",
        fontWeight: "700"
    }
};
const useStyles = makeStyles(styles);


const CoinWithdrawRequest = (props) => {
    const classes = useStyles();

    // state
    const [data, setData] = useState([])

    const columns = ([
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'email', headerName: 'Email', width: 300 },
        {
            field: 'action',
            headerName: 'Action',
            width:200,
            renderCell: (params: valueGetter) => {
    
                return (
                    <Fragment>
                        <Link to={'/eidt/' + params.row._id}>
                            <EditIcon style={{ color: "#109ebf" }} />
                        </Link>
                        <Link onClick={() => handleDelete(params.row._id)}>
                            <DeleteIcon style={{ color: "#109ebf" }} />
                        </Link>
                    </Fragment>
                )
            }
        },
    ])

    // function
    const fetchAllAdmin = async () => {
        try {
            const { status, loading, error, result } = await getAllAdmin();
            if (status == 'success') {
                let respData = result.map((item, key) => {
                    return {
                        id: key,
                        ...item
                    }
                })
                console.log(respData,'respp');
                setData(respData)
  
            } else { }
        } catch (err) { console.log(err,'========='); }
    }

    const handleDelete = async (id) => {
        try {
            if(window.confirm("Are You Sure Delete?")){
                const {status,message} = await deleteAdmin(id)
                if(status){
                    toastAlert('success',message,'deleteAdmin')
                    fetchAllAdmin()
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchAllAdmin()
    }, [])
    console.log(data,'dataaaa')
    return (
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Card>
                    <CardHeader color="primary">
                        <div className={classes.flexHeader}>
                            <h4 className={classes.cardTitleWhite}>Admin List</h4>
                            <Link to={'/add'} className={classes.btnPrimary}>Add Admin</Link>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <div style={{ height: 600, width: '100%' }}>
                            {
                                data.length > 0   && 
                            
                            <DataGrid pageSize={10} pagination rows={ data } columns={columns} />
                                            }
                        </div>
                    </CardBody>
                </Card>
            </Paper>
        </div >
    )
}

export default CoinWithdrawRequest;